module.exports = __webpack_public_path__ + "img/image9.7d61b6b2.jpeg";